const API_HOST = process.env.REACT_APP_SOUNDBOARD_API_HOST
export const SERVE_ROOT = process.env.REACT_APP_SOUNDBOARD_SERVE_ROOT

export const LOGIN_URL = `${API_HOST}api/token/`
export const REFRESH_URL = `${API_HOST}api/token/refresh/`
export const REGISTER_URL = `${API_HOST}registration/api/register/`
export const VERIFY_EMAIL_URL = `${API_HOST}registration/api/verify/`
export const SOUNDBOARD_POSITIONS_URL = `${API_HOST}soundboard/api/soundboardPositions/`
export const USER_DASHBOARD_URL = `${API_HOST}soundboard/api/userDashboard/`
export const DELETE_SLOT_ENTRY_URL = `${API_HOST}soundboard/api/deleteSlotEntry/`
export const UPLOAD_URL = `${API_HOST}soundboard/api/saveSlotEntry/`
export const PROMO_DASHBOARD_URL = `${API_HOST}soundboard/api/promoDashboard/`
export const DELETE_ACCOUNT_URL = `${API_HOST}soundboard/api/deleteAccount/`
